import { quizABTestRouteConfig } from '@/config/abTestConfig'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'

// Encouragement copy rotates by progress bucket (JumpSpeak-style).
function encouragementKey(pct: number): string {
  if (pct < 25) return 'pages.quizOnboarding.progress.greatStart'
  if (pct < 50) return 'pages.quizOnboarding.progress.keepGoing'
  if (pct < 75) return 'pages.quizOnboarding.progress.doingGreat'
  if (pct < 95) return 'pages.quizOnboarding.progress.almostThere'
  return 'pages.quizOnboarding.progress.lastStep'
}

function BackChevron() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path
        d="M15 5l-7 7 7 7"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default function QuizProgressHeader() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()

  // Ordered quiz steps, excluding the Flow landing page entry.
  const steps = quizABTestRouteConfig.baseline.filter(
    (slug) => slug !== 'question-language',
  )
  const currentSlug = location.pathname.split('/').filter(Boolean).pop() ?? ''
  const index = steps.indexOf(currentSlug)

  // First question shows a small non-zero value; last shows 100%.
  const pct =
    index < 0 || steps.length === 0
      ? 0
      : Math.round(((index + 1) / steps.length) * 100)

  const showBack = index > 0

  return (
    <div className="-mt-8 shrink-0 space-y-3">
      <div className="flex items-center gap-3">
        {showBack && (
          <button
            aria-label={t('shared.back', { defaultValue: 'Back' })}
            className="text-custom-black flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-[#EAEAEA] bg-white transition-opacity hover:opacity-70"
            data-testid="button-back"
            onClick={() => navigate(-1)}
            type="button"
          >
            <BackChevron />
          </button>
        )}

        <div className="h-2.5 grow overflow-hidden rounded-full bg-[#EEEEEE]">
          <div
            className="bg-primary h-full rounded-full transition-all duration-500 ease-out"
            style={{ width: `${pct}%` }}
          />
        </div>
      </div>

      <div
        className={`flex items-center justify-between ${showBack ? 'pl-12' : ''}`}
      >
        <p className="text-primary text-sm font-semibold">
          {t(encouragementKey(pct))}
        </p>
        <p className="text-primary text-sm font-bold">{pct}%</p>
      </div>
    </div>
  )
}
